import { resolveLanguage } from 'src/app/shared/language/_languages';

const SHOP_URLS: { [language: string]: string } = {
  de: 'https://medexam.app/produkt/pruefungsfragen/',
  en: 'https://medexam.app/en/product/exam-questions/',
  fr: 'https://medexam.app/fr/produit/pruefungsfragen/',
  it: 'https://medexam.app/it/prodotto/pruefungsfragen/'
};

const INACTIVE_SUBSCRIPTION = [
  'inactive',
  'expired',
  'canceled',
  'cancelled',
  'past_due',
  'unpaid',
  'none',
  'incomplete',
  'incomplete_expired'
];

export function subscriptionShopUrl(language: string | null | undefined): string {
  return SHOP_URLS[resolveLanguage(language)];
}

export function isSubscriptionRequired(error: any): boolean {
  return !!error && error.status === 403 && hasSubscriptionCode(error.error);
}

export function subscriptionBlocksMock(profile: any): boolean {
  const subscription = profile && profile.subscription;
  const status = subscription && subscription.status ? String(subscription.status).toLowerCase() : '';
  if (!status) {
    return false;
  }
  return INACTIVE_SUBSCRIPTION.indexOf(status) !== -1;
}

function hasSubscriptionCode(body: any): boolean {
  return readSubscriptionCode(body) === 'subscription_required';
}

function readSubscriptionCode(body: any): string {
  if (!body || typeof body !== 'object') {
    return '';
  }
  if (typeof body.code === 'string') {
    return body.code;
  }
  if (body.detail && typeof body.detail === 'object' && typeof body.detail.code === 'string') {
    return body.detail.code;
  }
  if (body.error && typeof body.error === 'object' && typeof body.error.code === 'string') {
    return body.error.code;
  }
  return '';
}
